import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { massUpdateAllMiraklOffers, getMiraklOffersMassUpdateStatus, bulkSyncMiraklOffers, exportFilmIBS } from '../services/api';
import { useMediaQuery } from 'react-responsive';

const ProdottiIBS = () => {
  const isMobile = useMediaQuery({ maxWidth: 991 });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [massUpdateImportId, setMassUpdateImportId] = useState(null);
  const [statusImportId, setStatusImportId] = useState('');
  const [importStatus, setImportStatus] = useState(null);

  // State for bulk sync file upload
  const [bulkSyncFile, setBulkSyncFile] = useState(null);
  const [bulkSyncLoading, setBulkSyncLoading] = useState(false);
  const [bulkSyncResult, setBulkSyncResult] = useState(null);
  const [bulkSyncError, setBulkSyncError] = useState(null);

  // State per export CSV OF01
  const [csvExportLoading, setCsvExportLoading] = useState(false);
  const [csvExportError, setCsvExportError] = useState(null);


  const handleMassUpdate = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    setMassUpdateImportId(null);
    try {
      const response = await massUpdateAllMiraklOffers();
      setMassUpdateImportId(response.data.import_id);
      setSuccess("Richiesta di aggiornamento massivo inviata con successo. Controlla lo stato usando l'ID.");
    } catch (err) {
      setError(err.response?.data?.detail || "Errore durante l'invio della richiesta di aggiornamento massivo.");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckStatus = async () => {
    if (!statusImportId) {
      setError("Inserisci un Import ID per controllare lo stato.");
      return;
    }
    setLoading(true);
    setError(null);
    setImportStatus(null);
    try {
      const response = await getMiraklOffersMassUpdateStatus(statusImportId);
      setImportStatus(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || "Errore durante il recupero dello stato dell'importazione.");
    } finally {
      setLoading(false);
    }
  };

  const handleExportCsvOf01 = async () => {
    setCsvExportLoading(true);
    setCsvExportError(null);
    try {
      const response = await exportFilmIBS();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const today = new Date().toISOString().split('T')[0].replace(/-/g, '');
      link.setAttribute('download', `offerte_ibs_OF01_${today}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setCsvExportError(err.response?.data?.detail || err.message || 'Errore durante il download del CSV.');
    } finally {
      setCsvExportLoading(false);
    }
  };

  const handleBulkSyncFileChange = (event) => {
    setBulkSyncFile(event.target.files[0]);
  };

  const handleBulkSyncSubmit = async () => {
    if (!bulkSyncFile) {
      setBulkSyncError("Seleziona un file da caricare.");
      return;
    }

    setBulkSyncLoading(true);
    setBulkSyncResult(null);
    setBulkSyncError(null);

    const formData = new FormData();
    formData.append('file', bulkSyncFile);

    try {
      const response = await bulkSyncMiraklOffers(formData);
      setBulkSyncResult(response.data);
    } catch (error) {
      console.error("Errore durante la sincronizzazione massiva da file:", error);
      setBulkSyncError(error.response?.data?.detail || error.message || "Errore sconosciuto durante la sincronizzazione massiva.");
    } finally {
      setBulkSyncLoading(false);
    }
  };


  return (
    <Container fluid className={isMobile ? "px-2" : ""}>
      <h1 className={`mb-4 ${isMobile ? 'h3' : ''}`}>Prodotti IBS</h1>
      <Row>
        {/* Card for Mass Update */}
        <Col md={12} className="mb-4">
          <Card>
            <Card.Header>
              <Card.Title>Aggiornamento Massivo Offerte Mirakl</Card.Title>
            </Card.Header>
            <Card.Body>
              <p className={`mb-3 ${isMobile ? 'small' : ''}`}>
                Questa sezione permette di aggiornare massivamente quantità e prezzi di tutti i prodotti (Film e Musica)
                contrassegnati con 'da_pubblicare_su_ibs' su Mirakl tramite importazione file (OF01).
              </p>
              <Button
                variant="primary"
                onClick={handleMassUpdate}
                disabled={loading}
                className="mt-2"
                size={isMobile ? "sm" : "md"}
              >
                {loading && !massUpdateImportId ? <Spinner as="span" animation="border" size="sm" /> : 'Avvia Aggiornamento Massivo'}
              </Button>

              {loading && massUpdateImportId && <Alert variant="info" className="mt-2">Richiesta inviata, in attesa di import_id...</Alert>}
              {error && <Alert variant="danger" className="mt-2">{error}</Alert>}
              {success && <Alert variant="success" className="mt-2">{success}</Alert>}
              {massUpdateImportId && (
                <Alert variant="info" className="mt-2">
                  Import ID: <strong>{massUpdateImportId}</strong>. Usalo per controllare lo stato.
                </Alert>
              )}

              <div className="mt-4">
                <h5 className={isMobile ? 'h6' : ''}>Controlla Stato Importazione Massiva</h5>
                <Form.Group className={`align-items-center mt-2 ${isMobile ? '' : 'd-flex'}`}>
                  <Form.Control
                    type="text"
                    placeholder="Inserisci Import ID"
                    value={statusImportId}
                    onChange={(e) => setStatusImportId(e.target.value)}
                    className={isMobile ? "mb-2" : "me-2"}
                    style={isMobile ? {} : { maxWidth: '300px' }}
                    size={isMobile ? "sm" : "md"}
                  />
                  <Button
                    variant="secondary"
                    onClick={handleCheckStatus}
                    disabled={loading}
                    size={isMobile ? "sm" : "md"}
                    className={isMobile ? "w-100" : ""}
                  >
                    {loading && statusImportId ? <Spinner as="span" animation="border" size="sm" /> : 'Controlla Stato'}
                  </Button>
                </Form.Group>

                {importStatus && (
                  <Card className="mt-2">
                    <Card.Body>
                      <h6 className={isMobile ? 'small' : ''}>Dettagli Stato Importazione:</h6>
                      <pre style={{ fontSize: isMobile ? '0.7rem' : '0.875rem', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                        {JSON.stringify(importStatus, null, 2)}
                      </pre>
                    </Card.Body>
                  </Card>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Card Scarica CSV Offerte OF01 */}
        <Col md={12} className="mb-4">
          <Card>
            <Card.Header>
              <Card.Title>Pubblica Nuove Offerte su IBS — Scarica CSV (OF01)</Card.Title>
            </Card.Header>
            <Card.Body>
              <p className={`mb-3 ${isMobile ? 'small' : ''}`}>
                Scarica il file CSV in formato <strong>OF01 Mirakl</strong> con tutti i film contrassegnati
                con <em>Pubblica su IBS</em>. Caricalo manualmente dal pannello IBS (Mirakl Seller) sotto
                <strong> Catalogo → Importa offerte</strong>. Questo metodo è più veloce delle API.
              </p>
              <Button
                variant="success"
                onClick={handleExportCsvOf01}
                disabled={csvExportLoading}
                size={isMobile ? 'sm' : 'md'}
              >
                {csvExportLoading
                  ? <><Spinner as="span" animation="border" size="sm" className="me-1" />Generazione CSV…</>
                  : 'Scarica CSV Offerte (OF01)'}
              </Button>
              {csvExportError && <Alert variant="danger" className="mt-3">{csvExportError}</Alert>}
            </Card.Body>
          </Card>
        </Col>

        {/* Card for Sincronizza Presente su IBS da File */}
        <Col md={12} className="mb-4">
          <Card>
            <Card.Header>
              <Card.Title>Sincronizzazione Flag 'da_pubblicare_su_ibs' da File IBS</Card.Title>
            </Card.Header>
            <Card.Body>
              <p className={`mb-3 ${isMobile ? 'small' : ''}`}>
                Carica un file Excel di inventario da IBS. Il sistema imposterà il flag 'da_pubblicare_su_ibs' a True per i prodotti
                il cui 'barcode_ibs' è presente nella colonna 'EAN' del file, e a False per gli altri.
              </p>
              <Form.Group controlId="formFile" className={`mb-3 ${isMobile ? '' : 'd-flex'} align-items-center`}>
                <Form.Label className={`mb-0 ${isMobile ? 'mb-2 d-block' : 'me-2'}`}>Seleziona File Excel:</Form.Label>
                <Form.Control
                  type="file"
                  accept=".xls,.xlsx"
                  onChange={handleBulkSyncFileChange}
                  className={isMobile ? "mb-2" : "w-auto me-2"}
                  size={isMobile ? "sm" : "md"}
                />
                {bulkSyncFile && <span className={`text-muted ${isMobile ? 'small d-block' : ''}`}>{bulkSyncFile.name}</span>}
              </Form.Group>
              <Button 
                variant="success" 
                onClick={handleBulkSyncSubmit} 
                disabled={!bulkSyncFile || bulkSyncLoading}
                size={isMobile ? "sm" : "md"}
                className={isMobile ? "w-100" : ""}
              >
                {bulkSyncLoading ? <Spinner as="span" animation="border" size="sm" /> : 'Avvia Riconciliazione'}
              </Button>

              {bulkSyncError && <Alert variant="danger" className="mt-3">{bulkSyncError}</Alert>}
              {bulkSyncResult && (
                <Alert variant="success" className="mt-3">
                  <h6 className={isMobile ? 'small' : ''}>Risultato Sincronizzazione:</h6>
                  <pre style={{ fontSize: isMobile ? '0.7rem' : '0.875rem', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {JSON.stringify(bulkSyncResult, null, 2)}
                  </pre>
                </Alert>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ProdottiIBS;